import React, { useEffect, useState } from "react";
import { api, AppProvider, useApp } from "./store.js";
import { Login } from "./components/Login.js";
import { Shell } from "./components/Shell.js";

function Gate() {
  const { session, setSession } = useApp();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    api.session()
      .then((s) => setSession(s))
      .catch(() => setSession(null))
      .finally(() => setChecked(true));
  }, [setSession]);

  if (!checked)
    return (
      <div style={{ height: "100vh", display: "grid", placeItems: "center", background: "#161826", color: "#75798c" }}>
        <i className="ph ph-circle-notch" style={{ fontSize: "22px", animation: "noc-spin 1s linear infinite" }} />
      </div>
    );

  return session ? <Shell /> : <Login />;
}

export function App() {
  return (
    <AppProvider>
      <Gate />
    </AppProvider>
  );
}
